<template>
  <div class="history-block" v-loading="loading">
    <div class="warp-column">
      <div class="dh-label">
        <el-button type="text" @click="openTree" :disabled="isHistoryScenario">选择数据</el-button>
      </div>
      <div class="dh-label">
        <el-button type="text" :disabled="resultObjectList.length === 0"
          @click="generateReportButtonHandler">生成报告</el-button>
      </div>
      <div class="dh-label">
        <el-button type="text" :disabled="resultObjectList.length === 0" @click="dialogTableVisible = true"
          v-if="!isHistoryScenario">下载数据</el-button>
      </div>
      <div class="dh-label">
        <el-button type="text" :disabled="resultObjectList.length === 0 || !this.isAdmin" @click="validDateDialog"
          v-if="!isHistoryScenario">有效日期</el-button>
      </div>
      <div class="dh-label" v-if="isAdmin && !isHistoryScenario">
        <el-button type="text" @click="monthReport">月度报告</el-button>
      </div>
      <div class="dh-label">
        <el-button type="text" @click="openTreeHumidityPercentage" :disabled="isHistoryScenario">湿度比例</el-button>
      </div>
      <div class="dh-label">
        <el-button type="text" @click="openTreeHumidityPercentageSetting"
          v-if="isHumidityPercentageTree && !isHistoryScenario">湿度比例配置</el-button>
      </div>
    </div>
    <history-chart ref="historyChart" v-if="resultObjectList.length > 0 && !loading" :xAxisData="xAxisData"
      :useHumiditySectionLine="useHumiditySectionLine" :humiditySectionLineMax="humiditySectionLineMax"
      :statusClass="statusClass" :range="numberRange" :legendData="legendData" :series="series"
      :isHumidityPercentage="isHumidityPercentageTree" :chartTitle="chartTitle"
      :seperateTemperatureYAxis="seperateTemperatureYAxis" :specialHourXAxis="search.specialHourXAxis"></history-chart>
    <!-- <history-data
      v-if="resultObjectList.length<3&&resultObjectList.length>0&&!loading"
      :useHumiditySectionLine="useHumiditySectionLine"
      :statusClass="statusClass"
      :range="numberRange"
      title="历史数据"
      :legendData="hdLegendData"
      :series="humidity1Data"
    ></history-data>-->
    <div class="no-device" v-if="resultObjectList.length === 0">
      <span>请选择桥梁数据</span>
    </div>
    <!--选择数据-->
    <el-dialog width="1040px" :visible.sync="dialogSelectVisible" :show-close="false" :close-on-click-modal="false"
      :close-on-press-escape="false">
      <div class="dialog-title humidity-percentage-title" slot="title" v-if="isHumidityPercentageTree">
        <div>
          湿度比例
          <span>(折线图一次最多选择10个数据展示)</span>
          已选({{ checkedDeviceList.length }})
        </div>
      </div>
      <div class="dialog-title" slot="title" v-else>
        选择数据
        <span>(折线图一次最多选择10个数据展示)</span>
        已选({{ checkedDeviceList.length }})
      </div>
      <div class="select-device" style="height: 401px; overflow: auto">
        <el-checkbox-group v-model="checkedDeviceList" :max="10">
          <el-tree ref="bridgeTree" class="bridge-tree tree-left" @node-expand="nodeExpand"
            @node-collapse="nodeCollapse" :data="treeData" :props="defaultProps" :load="loadNodeLeft"
            :render-content="renderContent" lazy></el-tree>
          <el-tree ref="bridgeTree1" class="bridge-tree tree-right" @node-expand="nodeExpandRight"
            @node-collapse="nodeCollapseRight" :data="treeDataRight" :props="defaultProps" :load="loadNodeRight"
            :render-content="renderContent" lazy></el-tree>
        </el-checkbox-group>
        <el-button class="clear-btn" type="text" @click="clearAllCheck"
          v-if="checkedDeviceList.length > 0">清空选择</el-button>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelSelectDeviec">取消</el-button>
        <el-button @click="doSelectDevice" type="primary">确定</el-button>
      </div>
    </el-dialog>
    <!--生成报告扩展-->
    <el-dialog width="1200px" title="包含的数据列表" :visible.sync="generateReportTableVisible">
      <div
        class="el-table el-table--fit el-table--border el-table--scrollable-y el-table--enable-row-hover el-table--enable-row-transition"
        style="width: 100%; height: 450px">
        <div class="el-table__header-wrapper">
          <table cellspacing="0" cellpadding="0" border="0" class="el-table__header" style="width: 100%">
            <thead class>
              <tr class="el-table-header__row">
                <th class="is-leaf">设备组</th>
                <th class="is-leaf">数据名称</th>
                <th class="is-leaf">在报告中包含数据</th>
              </tr>
            </thead>
          </table>
        </div>
        <div class="el-table__body-wrapper is-scrolling-none" style="height: 401px">
          <table cellspacing="0" cellpadding="0" border="0" class="el-table__body" style="width: 100%">
            <!-- <colgroup>
              <col width="450">
              <col width="360">
            </colgroup>-->
            <tbody>
              <template v-for="item in downloadDataList">
                <tr class="el-table__row" v-for="(child, index) in item.children" :key="child.index">
                  <td v-if="index === 0" :rowspan="item.children.length">
                    {{ item.label }}
                  </td>
                  <td class="generate-report-table-row">{{ child.label }}</td>
                  <td>
                    <el-switch v-model="generateReportTableModalList[child.index]" style="display: block"
                      active-color="#13ce66" inactive-color="#ff4949" active-text="包含数据" inactive-text="省略数据"
                      :ref="'generateReportTableSwitch_' + child.deviceId"></el-switch>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="generateReportTableVisible = false">取消</el-button>
        <el-button type="primary" @click="generateReportTableSubmit(false)">生成报告(保留窗口)</el-button>
        <el-button type="primary" @click="generateReportTableSubmit(true)">生成报告(关闭窗口)</el-button>
      </div>
    </el-dialog>
    <!--下载数据-->
    <el-dialog width="1200px" title="选中的数据列表" :visible.sync="dialogTableVisible">
      <div
        class="el-table el-table--fit el-table--border el-table--scrollable-y el-table--enable-row-hover el-table--enable-row-transition"
        style="width: 100%; height: 450px">
        <div class="el-table__header-wrapper">
          <table cellspacing="0" cellpadding="0" border="0" class="el-table__header" style="width: 100%">
            <!-- <colgroup>
              <col width="450">
              <col width="360">
            </colgroup>-->
            <thead class>
              <tr class="el-table-header__row">
                <th class="is-leaf">设备组</th>
                <th class="is-leaf">数据名称</th>
                <th class="is-leaf">统计间隔</th>
                <th class="is-leaf">导出数量</th>
                <th class="is-leaf">截止日期</th>
                <th class="is-leaf">下载数据</th>
              </tr>
            </thead>
          </table>
        </div>
        <div class="el-table__body-wrapper is-scrolling-none" style="height: 401px">
          <table cellspacing="0" cellpadding="0" border="0" class="el-table__body" style="width: 100%">
            <!-- <colgroup>
              <col width="450">
              <col width="360">
            </colgroup>-->
            <tbody>
              <template v-for="(item, _ind) in downloadDataList">
                <tr class="el-table__row" v-for="(child, index) in item.children" :key="index">
                  <td v-if="index === 0" :rowspan="item.children.length">
                    {{ item.label }}
                  </td>
                  <td>{{ child.label }}</td>
                  <td>
                    <el-select style="margin: 0 20px" @change="intervalChange(_ind, index, child['interval'])"
                      v-model="child['interval']" placeholder="请选择统计间隔">
                      <el-option label="不使用" value="NA"></el-option>
                      <el-option label="每日" value="BY_DAY"></el-option>
                      <el-option label="每小时" value="BY_HOUR"></el-option>
                      <el-option label="每周" value="BY_WEEK"></el-option>
                      <el-option label="每月" value="BY_MONTH"></el-option>
                    </el-select>
                  </td>
                  <td>
                    <el-select style="margin: 0 20px" @change="exportDataCountChange(_ind, index, child['dataCount'])"
                      v-model="child['dataCount']" placeholder="请选择数据数量">
                      <el-option label="无限制" value="0"></el-option>
                      <el-option v-for="item in exportNumOptions" :key="item.label" :value="item.value"
                        :id="item.value"></el-option>
                    </el-select>
                  </td>
                  <td>
                    <el-select style="margin: 0 20px" @change="exportEndDateChange(_ind, index, child['endDate'])"
                      v-model="child['endDate']" placeholder="请选择截止日期">
                      <el-option label="当前时间" value=""></el-option>
                      <el-option :label="search.dataDate" :value="search.dataDate"
                        v-if="exportEndDateValid"></el-option>
                    </el-select>
                  </td>
                  <td>
                    <el-button @click="doDownData(1, child)" type="text">下载数据</el-button>
                    <el-button @click="doDownData(2, child)" type="text">下载制备站数据</el-button>
                    <el-button @click="doDownData(3, child)" type="text" v-if="isAdmin">下载桥梁数据</el-button>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogTableVisible = false">关闭</el-button>
      </div>
    </el-dialog>
    <!--有效日期-->
    <el-dialog width="1200px" title="选中的数据列表" :visible.sync="validDateDialogVisible" v-loading="validDateDialogLoading">
      <div
        class="el-table el-table--fit el-table--border el-table--scrollable-y el-table--enable-row-hover el-table--enable-row-transition"
        style="width: 100%; height: 450px">
        <div class="el-table__header-wrapper">
          <table cellspacing="0" cellpadding="0" border="0" class="el-table__header" style="width: 100%">
            <!-- <colgroup>
              <col width="450">
              <col width="360">
            </colgroup>-->
            <thead class>
              <tr class="el-table-header__row">
                <th class="is-leaf">设备组</th>
                <th class="is-leaf">数据名称</th>
                <th class="is-leaf">统计间隔</th>
                <th class="is-leaf">起始数据日期</th>
                <th class="is-leaf">截止数据日期</th>
              </tr>
            </thead>
          </table>
        </div>
        <div class="el-table__body-wrapper is-scrolling-none" style="height: 401px">
          <table cellspacing="0" cellpadding="0" border="0" class="el-table__body" style="width: 100%">
            <!-- <colgroup>
              <col width="450">
              <col width="360">
            </colgroup>-->
            <tbody>
              <template v-for="(item, _ind) in validDateDataList">
                <tr class="el-table__row" v-for="(child, index) in item.children" :key="index">
                  <td v-if="index === 0" :rowspan="item.children.length">
                    {{ item.label }}
                  </td>
                  <td>{{ child.label }}</td>
                  <td>
                    <el-select style="margin: 0 20px" @change="intervalChange(_ind, index, child['interval'])"
                      v-model="child['interval']" placeholder="请选择统计间隔" disabled>
                      <el-option label="不使用" value="NA"></el-option>
                      <el-option label="每日" value="BY_DAY"></el-option>
                      <el-option label="每小时" value="BY_HOUR"></el-option>
                      <el-option label="每周" value="BY_WEEK"></el-option>
                      <el-option label="每月" value="BY_MONTH"></el-option>
                    </el-select>
                  </td>
                  <td v-if="child.validDate.HasValidResult">
                    {{ child.validDate.StartDateStatistics }}
                  </td>
                  <td v-if="child.validDate.HasValidResult">
                    {{ child.validDate.EndDateStatistics }}
                  </td>
                  <td v-if="!child.validDate.HasValidResult" colspan="2">
                    {{ child.validDate.message }}
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="validDateDialogVisible = false">确定</el-button>
      </div>
    </el-dialog>
    <!-- 月度报告 -->
    <el-dialog title="生成月度报告" custom-class="choseBridge" :visible.sync="bridgeFormVisible">
      <el-form :model="bridgeForm">
        <el-form-item class="monthly-report-form-input">
          <div class="monthly-report-form-input-key">报告截止日期</div>
          <el-date-picker v-model="monthlyReportEndDate" type="date" placeholder="报告截止日期"></el-date-picker>
        </el-form-item>
        <el-form-item class="monthly-report-form-input">
          <div class="monthly-report-form-input-key">报告选项</div>
          <el-checkbox v-model="imageOnlyReport" class="image-only-check">仅生成图片</el-checkbox>
        </el-form-item>
        <el-form-item>
          <div class="monthly-report-form-input-key">选择报告桥梁</div>
          <el-radio-group v-model="bridgeForm.bridge">
            <template v-for="item in birdgeList">
              <el-radio class="monthly-report-form-item" :label="item.id" :key="item.id" :name="item.id">{{ item.name
              }}</el-radio>
            </template>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div class="dialog-footer" slot="footer">
        <el-button @click="bridgeFormCancel">取 消</el-button>
        <el-button type="primary" @click="bridgeFormSubmit">确 定</el-button>
      </div>
    </el-dialog>
    <div class="month-report-text-wrap" v-if="monthReportTextShow">
      <i class="iconfont iconloading loading-icon-src"></i>
      <p class="gen">正在生成月度报告</p>
      <p v-for="(item, index) in monthReportText" :key="index">{{ item }}</p>
      <el-progress v-if="genneReportDeviceList.length > 0 && genneReportDeviceList.length < this.reportGroupListLength"
        :show-text="false" :stroke-width="10"
        :percentage="(genneReportDeviceList.length / this.reportGroupListLength) * 100"
        :format="percentageFormat"></el-progress>
    </div>
    <!-- 湿度比例柱状图配置 -->
    <el-dialog title="湿度比例柱状图配置" custom-class="choseBridge humidity-percentage-setting"
      :visible.sync="humidityPercentageSettingFormVisible">
      <el-form :model="bridgeForm">
        <el-form-item class="monthly-report-form-input">
          <div class="monthly-report-form-input-key">湿度下限</div>
          <el-input class="monthly-report-form-input-box" v-model="search_humidityPercentage.firstLine" type="number"
            placeholder="设定湿度下限" :disabled="isHistoryScenario">
          </el-input>
        </el-form-item>
        <el-form-item class="monthly-report-form-input">
          <div class="monthly-report-form-input-key">湿度上限</div>
          <el-input class="monthly-report-form-input-box" v-model="search_humidityPercentage.secondLine" type="number"
            placeholder="设定湿度上限" :disabled="isHistoryScenario">
          </el-input>
        </el-form-item>
        <el-form-item class="monthly-report-form-input">
          <div class="monthly-report-form-input-key">柱状图选项</div>
          <el-checkbox v-model="humidityPercentageDisplayAfterOnly" class="image-only-check">仅显示超限数据(红色柱)</el-checkbox>
        </el-form-item>
        <el-form-item class="monthly-report-form-input">
          <div class="monthly-report-form-input-key"></div>
          <el-switch v-model="humidityPercentageUseDailyStatisticsData" active-text="日抽样" inactive-text="小时抽样"
            active-color="#EE6666" inactive-color="#13ce66"></el-switch>
        </el-form-item>
        <el-form-item class="monthly-report-form-input">
          <div class="monthly-report-form-input-key"></div>
          <el-switch v-model="humidityPercentageIgnoreEmptyData" active-text="忽略空数据" inactive-text="计算空数据"
            active-color="#EE6666" inactive-color="#13ce66"></el-switch>
        </el-form-item>
      </el-form>
      <div class="dialog-footer" slot="footer">
        <el-button @click="humidityPercentageSettingFormCancel">取 消</el-button>
        <el-button type="primary" @click="humidityPercentageSettingFormSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>


<script>
import qs from "qs";
import { mapGetters } from "vuex";
import { dateTimeToString, newtonsoftJsonToDate, DistinctArray, StatisticsDateToDate } from "../tools/GeneralTool";
import { historyDataCountOptions } from "../constants.js";

const REFRESH_DATA_HISTROY_TIME = 300000;

const stationRightList = {
  南京夹江大桥: ["建邺侧空气处理", "浦口侧空气处理", "空气处理共用", "气夹", "气夹(塔顶排气)"],
  南沙大桥坭洲水道桥: ["坭洲3#制备站", "坭洲4#制备站", "坭洲6#制备站", "坭洲6#制备站高压风机", "坭洲气夹"],
  南沙大桥大沙水道桥: ["大沙3#制备站", "大沙4#制备站", "大沙6#制备站", "大沙6#制备站高压风机", "大沙气夹"],
  贵州清水河大桥: ["5#制备站气夹", "6#制备站气夹"],
  苏通大桥: ["常熟侧风阀", "常熟侧温湿度", "常熟侧除湿机", "常熟侧排风"],
  南京四桥: ["南制备站", "中制备站", "北制备站", "南鞍室(栖霞塔冠)", "北鞍室(六合塔冠)"],
  棋盘州大桥: ["黄冈侧西锚室", "黄冈侧东锚室", "黄冈中跨箱梁", "黄冈侧鞍室", "黄冈侧主缆", "南边跨下游箱梁"],
  虎门大桥: ["广州侧上游锚室", "广州侧下游锚室", "广州侧箱梁", "广州侧气夹", "广州侧主缆气罐", "广州侧主缆", "广州侧上游鞍室", "广州侧下游鞍室"],
  杭州湾大桥: ["宁波侧匝道桥(BD匝道)", "北航道北塔", "北航道南塔", "北航道箱梁"],
  西堠门大桥: [],
  西堠门大桥新风系统: [],
  西堠门大桥无线传感器: ["金塘岛侧气夹", "金塘岛侧索夹", "2#空气制备站(南塔)", "2#制备站能耗(南塔)"],
  宜昌大桥: ["上游气夹", "环境信息"],
  猎德大桥: ["环境信息"],
  江顺大桥: ["环境信息"],
  乐清湾大桥: ["环境信息"],
  金沙江大桥: ["丽江上游锚室(WINCC)", "丽江下游锚室(WINCC)", "丽江上游鞍室(WINCC)", "丽江下游鞍室(WINCC)", "丽江侧主缆(WINCC)",
      "丽江侧主缆(通讯箱)", "丽江侧主缆(PLC)", "丽江侧气夹(PLC)", "丽江鞍室(PLC)", "丽江锚室(PLC)", "QJ传感器组"
  ],
  贵州专项检测组桥: ["马岭河环境信息", "红枫湖环境信息", "北盘江环境信息", "坝陵河环境信息"],
  贵州坝陵河大桥: ["1#除湿机组(东-镇宁侧)", "2#除湿机组(西-胜境关侧)", "3#除湿机组(跨中)", "鞍室设备组", "测试设备组(停用)", "7+1高频采集箱(停用)"
    , "胜境关南侧鞍室设备组", "胜境关北侧鞍室设备组", "镇宁南侧鞍室设备组", "镇宁北侧鞍室设备组"],
  艾普瑞专项检测组桥: ["抵母河建大仁科传感器"],
  黄埔大桥: ["黄埔上游气夹"],
  嘉绍大桥: [
    "Z3中塔T2除湿机能耗(1#)",
    "Z3上塔T1除湿机能耗(2#)",
    "Z7上塔T9除湿机能耗(3#)",
    "Z8上塔T11除湿机能耗(4#)",
    "Z4上塔T3除湿机能耗(5#)",
    "Z5中塔T6除湿机能耗(6#)",
    "Z6上塔T7除湿机能耗(7#)",
    "Z4中塔T4除湿机能耗(8#)",
    "Z5Z1-L钢箱梁G8除湿机能耗(9#)",
    "Z7中塔T10除湿机能耗(10#)",
    "Z7B11-R钢箱梁G13除湿机能耗(11#)",
    "Z5上塔T5除湿机能耗(12#)",
    "Z4Z8-L钢箱梁G6除湿机能耗(13#)",
    "Z8B5-L钢箱梁G16除湿机能耗(14#)",
    "Z5Z1-R钢箱梁G7除湿机能耗(15#)",
    "Z6中塔T8除湿机能耗(16#)",
    "Z3B5-R钢箱梁G2除湿机能耗(17#)",
    "Z4B11-R钢箱梁G4除湿机能耗(18#)",
    "Z3B5-L钢箱梁G1除湿机能耗(19#)",
    "Z4B11-L钢箱梁G3除湿机能耗(20#)",
    "Z4Z8-R钢箱梁G5除湿机能耗(21#)",
    "J3-L刚性铰J3除湿机能耗(22#)",
    "J3-R刚性铰J1除湿机能耗(23#)",
    "J3-R刚性铰J2除湿机能耗(24#)",
    "Z7Z8-R钢箱梁G12除湿机能耗(25#)",
    "Z6Z1-R钢箱梁G10除湿机能耗(26#)",
    "J3-L刚性铰J4除湿机能耗(27#)",
    "Z8B5-R钢箱梁G15除湿机能耗(28#)",
    "Z8中塔T12除湿机能耗(29#)",
    "Z7Z8-L钢箱梁G11除湿机能耗(30#)",
    "Z6Z1-L钢箱梁G9除湿机能耗(31#)",
    "Z7B11-L钢箱梁G14除湿机能耗(32#)",
    "环境信息",
  ],
  嘉绍斜拉索试验: ["环境信息"],
  西江大桥: ["设备测试站"],
  矮寨大桥: ["环境信息"],
  北盘江大桥: ["胜境关南侧鞍室设备组", "胜境关北侧鞍室设备组", "镇宁南侧鞍室设备组", "镇宁北侧鞍室设备组"],
  时均数据分析桥: ["嘉绍时均分析组"]
};

export default {
  name: "HistoryBlock",
  props: {
    search: Object,
    search_humidityPercentage: Object,
    chartNumber: Number,
    seperateTemperatureYAxis: Boolean,
    isTime: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    isTime(val) {
      this.checkChange(val);
    },
    chartNumber() {
      this.getChartData();
    },
    search: {
      deep: true,
      handler() {
        if (this.search.dataDate === null) {
          this.search.dataDate = "";
        }
        if (this.search.removeZero === null || this.search.removeZero === undefined) {
          this.search.removeZero = false;
        }

        this.refreshDownloadDataList();
        if (!this.loadingFullScreen && !this.isHumidityPercentageTree && !this.isHistoryScenario) {
          this.getChartData();
        }
      },
    },
    search_humidityPercentage: {
      deep: true,
      handler() {
        //this.refreshDownloadDataList();
        if (!this.loadingFullScreen && this.isHumidityPercentageTree) {
          this.getChartData_humidityPercentage();
        }
      },
    },
    humidityPercentageUseDailyStatisticsData: {
      handler(val) {
        if (val === true) {
          this.$confirm('日抽样数据分析精度较低, 仅用于日均湿度设备分析. 如果您选择的一般设备仅有日抽样数据, 请联系管理员进行小时抽样数据归档恢复操作.', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
          }).then(() => {
            //pass
          }).catch(() => {
            this.humidityPercentageUseDailyStatisticsData = false;
          })
        }
      },
    },
    resultObjectList: {
      deep: true,
      handler(val) {
        this.refreshDownloadDataList();
      },
    },
    isHumidityPercentageTree: {
      handler(val) {
        this.$emit("setHumidityPercentage", val);
      },
    },
  },
  created() {
    this.checkChange(this.isTime);
    const treeData = this.bridgeList.map((bridge) => {
      return { label: bridge.name, bridgeId: bridge.id, deviceId: bridge.id };
    });
    this.bridgeList.forEach((bridge) => {
      this.nodeIdNodeNameDict[bridge.id] = bridge.name;
    });
    this.treeData = [...treeData];
    this.treeDataRight = treeData.filter((el) => {
      return !!stationRightList[el.label];
    });
  },
  mounted() {
    this.exportNumOptions = historyDataCountOptions;
  },
  data() {
    return {
      loadingFullScreen: null,
      HistoryBlock: true,
      useHumiditySectionLine: false,
      useCondensation95Line: false,
      humiditySectionLineMax: 0,
      numberRange: "",
      statusClass: "",
      stationDataGroupCache: {},
      nodeIdNodeNameDict: {},
      nodeIdParentIdDict: {},
      chartTitle: "",
      generateReportName: "",
      hdLegendData: [],
      humidity1Data: [],
      loading: false,
      downloadDataList: [],
      validDateDataList: [],
      checkedDeviceList: [],
      checkedDeviceObjectList: [],
      resultIdList: [],
      resultObjectList: [],
      dialogSelectVisible: false,
      defaultProps: { children: "children", label: "label", isLeaf: "leaf" },
      treeData: [],
      treeDataRight: [],
      dialogTableVisible: false,
      generateReportTableVisible: false,
      validDateDialogVisible: false,
      validDateDialogLoading: false,
      bridgeForm: {
        bridge: "",
      },
      birdgeList: [],
      bridgeFormVisible: false,
      humidityPercentageSettingFormVisible: false,
      humidityPercentageUseDailyStatisticsData: false,
      humidityPercentageResultUseDailyStatisticsData: false,
      humidityPercentageIgnoreEmptyData: false,
      humidityPercentageResultIgnoreEmptyData: false,
      isSetTime: false,
      xAxisData: [],
      series: [],
      legendData: [],
      timeFunc: null,
      isOnce: false,
      statisticsInterval: [],
      monthReportTextShow: false,
      monthReportText: [],
      reportGroupList: [],
      genneReportDeviceList: [],
      reportGroupListLength: 0,
      drawEchartsFailTimes: 0,
      monthlyReportEndDate: new Date(),
      monthlyReportInProgress: false,
      isHumidityPercentageTree: false,
      hourlyStatisticsDataExpireDays: 90,
      isHistoryScenario: false,
      isStatisticsAccessApproved: false,
      isHumidityChart: false,
      exportNumOptions: [],
      imageOnlyReport: false,
      humidityPercentageDisplayAfterOnly: false,

      // generateReportTableModalList: [[], [], [], [], [], [], [], [], [], []],
      generateReportTableModalList: [],
    };
  },
  computed: {
    ...mapGetters({
      isAdmin: "getIsAdmin",
      bridgeList: "getBridgeList",
    }),
    bridgeName() {
      const bri = this.birdgeList.filter((el) => el.id === this.$route.query.bridgeId);
      return bri[0].name;
    },
    exportEndDateValid() {
      return this.search && this.search.dataDate && this.search.dataDate !== "";
    },
  },
  beforeDestroy() {
    try {
      this.loadingFullScreen.close();
    } catch (error) {
      // pass
      // console.log(error);
    }
    this.loadingFullScreen = null;
    this.drawEchartsFailTimes = 0;
  },
  methods: {
    assembleChartTitle_humidityPercentage(firstDataDate, lastDataDate, daysCount, deviceIdList) {
      let result = "";
      let reportNameResult = "";

      if (firstDataDate && lastDataDate) {
          result += firstDataDate + " - " + lastDataDate + " ";
      }

      //get device(group) name if possible
      let deviceNameList = [];
      let stationNameList = [];
      let bridgeNameList = [];
      deviceIdList.forEach((deviceId) => {
        let deviceName = this.nodeIdNodeNameDict[deviceId];
        let stationId = this.nodeIdParentIdDict[deviceId];
        if (deviceName) {
          deviceNameList.push(deviceName);
        }
        if (stationId) {
          let stationName = this.nodeIdNodeNameDict[stationId];
          let bridgeId = this.nodeIdParentIdDict[stationId];
          if (stationName) {
            stationNameList.push(stationName);
          }
          if (bridgeId) {
            let bridgeName = this.nodeIdNodeNameDict[bridgeId];
            if (bridgeName) {
              bridgeNameList.push(bridgeName);
            }
          }
        }
      });

      deviceNameList = DistinctArray(deviceNameList);
      stationNameList = DistinctArray(stationNameList);
      bridgeNameList = DistinctArray(bridgeNameList);

      if (deviceNameList.length === 1) {
        //show station name for only 1 device. deivce name is already in legend
        // reportNameResult += deviceNameList[0] + " ";
        reportNameResult += stationNameList[0] + " ";
      } else {
        for (let i = 0; i < deviceNameList.length; i++) {
          let deviceNameItem = deviceNameList[i];
          if (
            deviceNameItem.indexOf("室外温度") == 0 ||
            deviceNameItem.indexOf("室外湿度") == 0 ||
            deviceNameItem.indexOf("室外天气") == 0 ||
            deviceNameItem.indexOf("室外时均湿度") == 0 ||
            deviceNameItem.indexOf("室外日均湿度") == 0 ||
            deviceNameItem.indexOf("室外时均温度") == 0 ||
            deviceNameItem.indexOf("室外日均温度") == 0
          ) {
            deviceNameList.splice(i, 1);
            i--;
          }
        }

        if (deviceNameList.length === 1) {
          //show station name for only 1 device. deivce name is already in legend
          // reportNameResult += deviceNameList[0] + " ";
          reportNameResult += stationNameList[0] + " ";
        }
      }

      if (reportNameResult === "") {
        if (stationNameList.length === 1) {
          reportNameResult += stationNameList[0] + " ";
        } else {
          while (stationNameList.indexOf("环境信息") >= 0) {
            stationNameList.splice(stationNameList.indexOf("环境信息"), 1);
          }
          if (stationNameList.length === 1) {
            reportNameResult += stationNameList[0] + " ";
          } else {
            if (bridgeNameList.length === 1) {
              reportNameResult += bridgeNameList[0] + " ";
            }
          }
        }
      }

      //get search interval and count
      reportNameResult += daysCount + "日";

      if (this.humidityPercentageIgnoreEmptyData || this.humidityPercentageResultIgnoreEmptyData) {
        reportNameResult += "有效数据";
      }

      //get device type
      reportNameResult += "湿度比例";

      if (this.humidityPercentageUseDailyStatisticsData || this.humidityPercentageResultUseDailyStatisticsData) {
        reportNameResult += "(日抽样)";
      }

      result += reportNameResult;
      this.generateReportName = reportNameResult;
      return result;
    },
    assembleChartTitle_monthly(dataDateList, deviceIdList, reportGroupName) {
      let result = "";

      //get start/end date
      let startDate = undefined;
      let endDate = undefined;
      dataDateList.forEach((dataDate) => {
        let date = newtonsoftJsonToDate(dataDate);
        if (date) {
          if (startDate) {
            if (startDate.getTime() > date.getTime()) {
              startDate = date;
            }
          } else {
            startDate = date;
          }

          if (endDate) {
            if (endDate.getTime() < date.getTime()) {
              endDate = date;
            }
          } else {
            endDate = date;
          }
        }
      });
      if (startDate && endDate) {
        let format = "YY年MM月dd日HH时";
        if (this.search.interval === "BY_DAY") {
          format = "YY年MM月dd日";
        } else if (this.search.interval === "BY_MONTH") {
          format = "YYYY年MM月";
        }
        result += dateTimeToString(startDate, format) + " - " + dateTimeToString(endDate, format) + " ";
      }

      //use group name
      result += reportGroupName + " ";

      //get search interval and count
      let count = this.search.count;
      let interval = this.search.interval;
      if (interval === "BY_HOUR") {
        result += count + "小时";
      } else if (interval === "BY_DAY") {
        result += count + "日";
      } else if (interval === "BY_WEEK") {
        result += count + "周";
      } else if (interval === "BY_MONTH") {
        result += count + "月";
      } else {
        result += count;
      }

      //get device type
      let humidityCount = 0;
      let temperatureCount = 0;
      let otherCount = 0;
      deviceIdList.forEach((deviceId) => {
        let deviceName = this.nodeIdNodeNameDict[deviceId];
        if (deviceName) {
          if (deviceName.indexOf("温度") >= 0) {
            temperatureCount++;
          } else if (deviceName.indexOf("湿度") >= 0) {
            humidityCount++;
          } else {
            otherCount++;
          }
        }
      });
      if (otherCount > 0) {
        result += "数据曲线";
      } else if (humidityCount > 0 && temperatureCount > 0) {
        result += "温湿度曲线";
      } else if (humidityCount > 0) {
        result += "湿度曲线";
      } else if (temperatureCount > 0) {
        result += "温度曲线";
      } else {
        result += "数据曲线";
      }

      return result;
    },
    assembleChartTitle(dataDateList, deviceIdList) {
      let result = "";
      let reportNameResult = "";

      //get start/end date
      let startDate = undefined;
      let endDate = undefined;
      dataDateList.forEach((dataDate) => {
        let date = newtonsoftJsonToDate(dataDate);
        if (date) {
          if (startDate) {
            if (startDate.getTime() > date.getTime()) {
              startDate = date;
            }
          } else {
            startDate = date;
          }

          if (endDate) {
            if (endDate.getTime() < date.getTime()) {
              endDate = date;
            }
          } else {
            endDate = date;
          }
        }
      });
      if (startDate && endDate) {
        let format = "YY年MM月dd日HH时";
        if (this.search.interval === "BY_DAY") {
          format = "YY年MM月dd日";
        } else if (this.search.interval === "BY_MONTH") {
          format = "YYYY年MM月";
        }
        result += dateTimeToString(startDate, format) + " - " + dateTimeToString(endDate, format) + " ";
      }

      //get device(group) name if possible
      let deviceNameList = [];
      let stationNameList = [];
      let bridgeNameList = [];
      deviceIdList.forEach((deviceId) => {
        let deviceName = this.nodeIdNodeNameDict[deviceId];
        let stationId = this.nodeIdParentIdDict[deviceId];
        if (deviceName) {
          deviceNameList.push(deviceName);
        }
        if (stationId) {
          let stationName = this.nodeIdNodeNameDict[stationId];
          let bridgeId = this.nodeIdParentIdDict[stationId];
          if (stationName) {
            stationNameList.push(stationName);
          }
          if (bridgeId) {
            let bridgeName = this.nodeIdNodeNameDict[bridgeId];
            if (bridgeName) {
              bridgeNameList.push(bridgeName);
            }
          }
        }
      });

      deviceNameList = DistinctArray(deviceNameList);
      stationNameList = DistinctArray(stationNameList);
      bridgeNameList = DistinctArray(bridgeNameList);

      if (deviceNameList.length === 1) {
        //show station name for only 1 device. deivce name is already in legend
        // reportNameResult += deviceNameList[0] + " ";
        reportNameResult += stationNameList[0] + " ";
      } else {
        for (let i = 0; i < deviceNameList.length; i++) {
          let deviceNameItem = deviceNameList[i];
          if (
            deviceNameItem.indexOf("室外温度") == 0 ||
            deviceNameItem.indexOf("室外湿度") == 0 ||
            deviceNameItem.indexOf("室外天气") == 0 ||
            deviceNameItem.indexOf("室外时均湿度") == 0 ||
            deviceNameItem.indexOf("室外日均湿度") == 0 ||
            deviceNameItem.indexOf("室外时均温度") == 0 ||
            deviceNameItem.indexOf("室外日均温度") == 0
          ) {
            deviceNameList.splice(i, 1);
            i--;
          }
        }

        if (deviceNameList.length === 1) {
          //show station name for only 1 device. deivce name is already in legend
          // reportNameResult += deviceNameList[0] + " ";
          reportNameResult += stationNameList[0] + " ";
        }
      }

      if (reportNameResult === "") {
        if (stationNameList.length === 1) {
          reportNameResult += stationNameList[0] + " ";
        } else {
          while (stationNameList.indexOf("环境信息") >= 0) {
            stationNameList.splice(stationNameList.indexOf("环境信息"), 1);
          }
          if (stationNameList.length === 1) {
            reportNameResult += stationNameList[0] + " ";
          } else {
            if (bridgeNameList.length === 1) {
              reportNameResult += bridgeNameList[0] + " ";
            }
          }
        }
      }

      //get search interval and count
      let count = this.search.count;
      let interval = this.search.interval;
      if (interval === "BY_HOUR") {
        reportNameResult += count + "小时";
      } else if (interval === "BY_DAY") {
        reportNameResult += count + "日";
      } else if (interval === "BY_WEEK") {
        reportNameResult += count + "周";
      } else if (interval === "BY_MONTH") {
        reportNameResult += count + "月";
      } else {
        reportNameResult += count;
      }

      //get device type
      let humidityCount = 0;
      let temperatureCount = 0;
      let otherCount = 0;
      deviceIdList.forEach((deviceId) => {
        let deviceName = this.nodeIdNodeNameDict[deviceId];
        if (deviceName) {
          if (deviceName.indexOf("温度") >= 0) {
            temperatureCount++;
          } else if (deviceName.indexOf("湿度") >= 0) {
            humidityCount++;
          } else {
            otherCount++;
          }
        }
      });
      if (otherCount > 0) {
        reportNameResult += "数据曲线";
      } else if (humidityCount > 0 && temperatureCount > 0) {
        reportNameResult += "温湿度曲线";
      } else if (humidityCount > 0) {
        reportNameResult += "湿度曲线";
      } else if (temperatureCount > 0) {
        reportNameResult += "温度曲线";
      } else {
        reportNameResult += "数据曲线";
      }

      result += reportNameResult;
      this.generateReportName = reportNameResult;
      return result;
    },
    translateXAxisStatisticsDate(input) {
      // let result = input.replace(" ", "\n");
      // return result;

      let result = input.replace("年", "/").replace("月", "/").replace("日", "");

      //fix by_month statistics like 21/11/
      if (result.endsWith("/")) {
        result = result.slice(0, -1);
      }

      return result;
    },
    setHistoryScenario(scenarioModel, deviceIdList) {
      this.isHistoryScenario = true;
      this.loading = true;

      //verify device id in scenario
      let checkedDeviceList = [];
      for (let scenario of scenarioModel.checkedDeviceObjectList) {
        if (deviceIdList.indexOf(scenario.deviceId) >= 0) {
          checkedDeviceList.push(scenario.deviceId);
        } else {
          this.$alert(`历史场景中检测到无效的数据: ` + scenario.label + ", 请联系管理员.", {
            confirmButtonText: "确定",
            showClose: false,
            type: "error",
            callback: (action) => {
              // console.log('stop');
              // this.resultObjectList = [];
            },
          });

          return;
        }
      }

      //set parameters and refresh data
      this.checkedDeviceList = checkedDeviceList;
      this.checkedDeviceObjectList = scenarioModel.checkedDeviceObjectList;
      this.isHumidityPercentageTree = scenarioModel.isHumidityPercentageTree;
      this.$nextTick(() => {
        this.doSelectDevice();
      });

      setTimeout(() => {
        this.loading = false;
      }, 5000);
    },
    setEmptyHistoryScenario() {
      console.log("set empty history scenario");
      this.checkedDeviceList = [];
      this.checkedDeviceObjectList = [];
      this.isHumidityPercentageTree = false;
      this.isHistoryScenario = true;
      this.doSelectDevice();
    },
    releaseHistoryScenario() {
      this.isHistoryScenario = false;
      this.doSelectDevice();
    },
    setIsStatisticsAccessApproved(value) {
      this.isStatisticsAccessApproved = value;
      // console.log('is statistics access approved set to history block: '+value);
    },
    getHistoryScenario() {
      let deviceIdList = [];
      let bridgeIdList = [];
      for (let device of this.checkedDeviceObjectList) {
        deviceIdList.push(device.deviceId);

        if (bridgeIdList.indexOf(device.bridgeId < 0)) {
          bridgeIdList.push(device.bridgeId);
        }
      }

      let historyScenarioModel = {};
      historyScenarioModel.deviceIdList = deviceIdList;
      historyScenarioModel.bridgeIdList = bridgeIdList;
      historyScenarioModel.checkedDeviceObjectList = this.checkedDeviceObjectList;
      historyScenarioModel.isHumidityPercentageTree = this.isHumidityPercentageTree;

      return historyScenarioModel;
    },
    dateDiffByDay(dateA, dateB) {
      let diffMs = Math.abs(dateA.getTime() - dateB.getTime());
      let result = parseInt(diffMs / (1000 * 60 * 60 * 24));
      return result;
    },
    refreshDownloadDataList() {
      const ary = [];
      const len = this.resultObjectList.length;
      if (len > 0) {
        let obj = { label: this.resultObjectList[0].ascription, children: [] };
        let stationId = this.resultObjectList[0].stationId;
        this.resultObjectList.forEach((val, index) => {
          if (stationId === val.stationId) {
            val.interval = this.search.interval || "NA";
            val.dataCount = this.search.count;
            val.endDate = this.search.dataDate;
            val.index = index;
            obj.children.push(val);
          } else {
            ary.push(obj);
            obj = { label: val.ascription, children: [] };
            stationId = val.stationId;
            val.interval = this.search.interval || "NA";
            val.dataCount = this.search.count;
            val.endDate = this.search.dataDate;
            val.index = index;
            obj.children.push(val);
          }
          if (index === len - 1) ary.push(obj);
        });
      }
      this.downloadDataList = ary;
    },
    percentageFormat(percentage) {
      return percentage.toFixed(2) + "%"; // (percentage / this.reportGroupListLength * 100).toFixed(2) + '%'
    },
    loadingFullScreenClose() {
      this.loadingFullScreen.close();
      this.monthReportTextShow = false;
      this.monthReportText = [];
      this.reportGroupList = [];
      this.genneReportDeviceList = [];
      this.reportGroupListLength = 0;

      this.$nextTick().then(() => {
        this.loadingFullScreen = null;
      });
    },
    openTreeHumidityPercentage() {
      this.isHumidityPercentageTree = true;
      this.openTreeBase();
    },
    openTreeHumidityPercentageSetting() {
      this.humidityPercentageSettingFormVisible = true;
    },
    openTree() {
      this.isHumidityPercentageTree = false;
      this.openTreeBase();
    },
    openTreeBase() {
      this.dialogSelectVisible = true;

      if (!this.isOnce) {
        this.isOnce = true;
        const $index = this.treeData.findIndex((val) => val.bridgeId === this.$route.query.bridgeId);
        this.$nextTick(() => {
          if ($index > -1) {
            this.$refs.bridgeTree.treeItems[$index].click();
            try {
              this.$refs.bridgeTree1.treeItems[$index].click();
            } catch (error) {
              console.error(error);
            }
          }
        });
      }
    },
    //生成报告按钮
    generateReportButtonHandler() {
      //reset all switch to on
      for (let i = 0; i < 10; i++) {
        this.generateReportTableModalList[i] = true;
      }

      if (this.isAdmin) {
        this.generateReportTableVisible = true;
      } else {
        this.Screenshot(true);
      }
    },
    generateReportTableSubmit(closeTable) {
      this.Screenshot(false);

      if (closeTable) {
        this.generateReportTableVisible = false;
      }
    },
    //生成报告1 - 上传图片
    Screenshot(skipOmitDataDeviceCheck) {
      console.log("Screenshot");
      const historyChart = this.$refs.historyChart.historyChart;
      const dataSrc = historyChart.getDataURL({
        pixelRatio: 2,
        backgroundColor: "#fff",
      });
      const title = historyChart.getOption().title[0].text || "";
      const myFile = this.dataURLtoFile(dataSrc, `${title}.png`);
      let form = new FormData();
      form.append("file", myFile);
      this.loadingFullScreen = this.$loading({
        lock: true,
        text: "正在生成报告",
        spinner: "iconfont iconloading loading-icon-src",
        background: "rgba(rgba(255, 255, 255, 0.9))",
      });
      this.$http
        .post("/echartReport/UploadEchartReportImage", form)
        .then((res) => {
          if (res.data && res.data.imageFileId) {
            this.GenerateReport(res.data.imageFileId, skipOmitDataDeviceCheck);
          }
        })
        .catch((error) => {
          console.log("error", error);
          this.loadingFullScreenClose();
        });
    },
    //生成报告2 - 生成报告
    GenerateReport(imageFileId, skipOmitDataDeviceCheck) {
      const deviceList = this.checkedDeviceList || [];
      if (deviceList.length === 0) {
        return;
      }

      let omitDataDeviceIdList = [];
      if (!skipOmitDataDeviceCheck) {
        console.log("check omit data device");
        for (let deviceId of deviceList) {
          let refsName = "generateReportTableSwitch_" + deviceId;
          let refList = this.$refs[refsName];
          if (refList && refList[0]) {
            let switchItem = refList[0];
            if (switchItem.value === false) {
              omitDataDeviceIdList.push(deviceId);
            }
          }
        }
      }
      console.log("omit data device id list: " + JSON.stringify(omitDataDeviceIdList) + ", is humidity percentage: " + this.isHumidityPercentageTree);

      const _data = {
        deviceIdList: deviceList,
        echartReportImageId: imageFileId,
        reportName: this.generateReportName,
        omitDataDeviceIdList: omitDataDeviceIdList,
      };

      if(this.isHumidityPercentageTree){
        _data.isHumidityPercentage = true;
        _data.humidityPercentageFirstLine = this.search_humidityPercentage.firstLine;
        _data.humidityPercentageSecondLine = this.search_humidityPercentage.secondLine;
        _data.count = this.search_humidityPercentage.daysCount;
        _data.dataDate = this.search_humidityPercentage.dataDate;
        _data.humidityPercentageUseDailyData = this.humidityPercentageUseDailyStatisticsData;
        _data.humidityPercentageIgnoreEmptyData = this.humidityPercentageIgnoreEmptyData;
      }
      else{
        Object.assign(_data, this.search);
        _data.isHumidityPercentage = false;
      }


      this.$http
        .post("/echartReport/GenerateEchartReport", _data)
        .then((res) => {
          if (res.data && res.data.reportId) {
            this.downloadEchartReport(res.data.reportId);
          }
        })
        .catch((error) => {
          console.log("error", error);
          this.loadingFullScreenClose();
        });
    },
    //生成报告3 - 下载报告
    downloadEchartReport(reportId) {
      this.loadingFullScreenClose();
      this.$alert(`报告生成完毕，请点击下载`, "提示", {
        confirmButtonText: "下载",
        showClose: false,
        type: "success",
      }).then(() => {
        const $url = "/echartReport/DownloadEchartReport?reportId=" + reportId;
        window.open($url);
      });
    },
    monthReport() {
      this.loadingFullScreen = this.$loading({
        lock: true,
        text: "加载桥梁列表",
        spinner: "iconfont iconloading loading-icon-src",
        background: "rgba(rgba(255, 255, 255, 0.9))",
      });
      this.$http.get("/bridge/BridgeList").then((res) => {
        this.birdgeList = res.data.map((el) => {
          return {
            id: el.bridgeId,
            name: el.bridgeName,
          };
        });
        this.bridgeForm = { bridge: this.$route.query.bridgeId };
        this.imageOnlyReport = false;
        this.loadingFullScreenClose();
        this.bridgeFormVisible = true;
      });
    },
    validDateDialog() {
      this.validDateDataList = [];
      this.validDateDialogLoading = true;
      this.validDateDialogVisible = true;
      let deviceIdList = [];
      let interval = "";
      for (let station of this.downloadDataList) {
        for (let device of station.children) {
          deviceIdList.push(device.deviceId);
          interval = device.interval;
        }
      }

      let validDateRequestList = [];
      for (let deviceId of deviceIdList) {
        validDateRequestList.push(this.$http.get("/statistics/DeviceValidDataDateRange?deviceId=" + deviceId + "&interval=" + interval));
      }

      this.$http.all(validDateRequestList).then(
        this.$http.spread((...resList) => {
          let deviceIdValidDateDict = {};
          for (let res of resList) {
            var deviceId = res.data.deviceId;
            var validDate = res.data;
            deviceIdValidDateDict[deviceId] = validDate;
          }

          let validDateDataList = JSON.parse(JSON.stringify(this.downloadDataList));
          for (let station of validDateDataList) {
            for (let device of station.children) {
              device.validDate = deviceIdValidDateDict[device.deviceId];
            }
          }

          this.validDateDataList = validDateDataList;

          this.validDateDialogLoading = false;
        })
      );
    },
    bridgeFormCancel() {
      this.bridgeFormVisible = false;
    },
    bridgeFormSubmit() {
      this.$confirm("月度报告生成耗时较长. 生成期间请不要离开页面或关闭浏览器.", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.monthlyReportInProgress = true;

          // let searchOption = {
          //   interval: "BY_HOUR",
          //   count: 744,
          //   dataDate: this.dateTimeToString(this.monthlyReportEndDate, "yyyy-MM-dd HH:mm"),
          //   insertBlankData: true,
          // };
          // const reportEndDateDiffByDay = this.dateDiffByDay(new Date(), this.monthlyReportEndDate);
          // if (reportEndDateDiffByDay >= 60) {
          //   searchOption.interval = "BY_DAY";
          //   searchOption.count = 31;
          // }
          // this.$emit("setSearchConfig", searchOption);

          this.bridgeFormVisible = false;
          this.checkedDeviceList = [];
          this.checkedDeviceObjectList = [];
          this.genneReportDeviceList = [];
          this.getBridgeStationList();
        })
        .catch(() => {
          this.bridgeFormVisible = false;
          this.monthlyReportInProgress = false;
        });
    },
    humidityPercentageSettingFormSubmit() {
      this.humidityPercentageSettingFormVisible = false;
      if (this.resultObjectList.length === 0) return;

      this.loading = true;
      this.doSelectDevice();
    },
    humidityPercentageSettingFormCancel() {
      this.humidityPercentageSettingFormVisible = false;
    },
    /**
     * 获取制备站列表
     */
    getBridgeStationList() {
      this.loadingFullScreen = this.$loading({
        lock: true,
        text: "正在生成月度报告...",
        spinner: "iconfont iconloading loading-icon-src",
        background: "rgba(0, 0, 0, 0.5)",
      });
      let groupList = [];
      this.monthReportTextShow = true;
      this.genneReportDeviceList = [];
      this.monthReportTextAdd("正在获取桥梁月报分组...");
      this.$http
        .get(`/echartReport/GetMonthlyReportGroup?bridgeId=${this.bridgeForm.bridge}`)
        .then((res) => {
          res.data.forEach((el) => {
            groupList.push(el);
          });
          this.resultObjectList = [];
          this.multiReportGenne(groupList);
        })
        .catch(() => {
          this.loadingFullScreenClose();
          this.monthlyReportInProgress = false;
        });
    },
    /**
     * 添加进程
     */
    monthReportTextAdd(text) {
      if (this.monthReportText.length > 5) {
        const monthReportText = JSON.parse(JSON.stringify(this.monthReportText));
        monthReportText.shift();
        this.monthReportText = monthReportText;
      }
      this.monthReportText.push(text);
    },
    /**
     * 添加进程
     */
    monthReportTextModify(text) {
      this.$set(this.monthReportText, this.monthReportText.length - 1, text);
    },
    updateSearchOptions(groupName) {
      //对于日均湿度数据和时间久远的月报数据, 使用日抽样. 其他情况使用小时抽样
      let searchOption = {
        interval: "BY_HOUR",
        count: 744,
        dataDate: dateTimeToString(this.monthlyReportEndDate, "yyyy-MM-dd HH:mm"),
        insertBlankData: true,
      };
      const reportEndDateDiffByDay = this.dateDiffByDay(new Date(), this.monthlyReportEndDate);
      if (reportEndDateDiffByDay >= 120 || groupName.indexOf("日均") >= 0) {
        searchOption.interval = "BY_DAY";
        searchOption.count = 31;
      }
      this.$emit("setSearchConfig", searchOption);
    },
    multiReportGenne(groupList) {
      this.monthReportTextAdd(`开始截图生成报告...`);
      this.reportGroupList = groupList;
      this.reportGroupListLength = groupList.length;
      this.resultObjectList = [this.reportGroupList.shift()];

      this.updateSearchOptions(this.reportGroupList[0].groupName);

      this.$nextTick().then(() => {
        this.monthReportTextModify(
          `正在绘制 ${this.resultObjectList[0].groupName} (${this.genneReportDeviceList.length}/${this.reportGroupListLength})`
        );
        this.getReportChartData();
      });
    },
    /**
     * 请求图表数据, 月报
     */
    getReportChartData() {
      this.loading = true;
      const deviceIdList = [];
      const dataDateList = [];
      const httpAry = [];
      const xAxisData = [];
      const series = [];
      const legendData = [];
      const humidity1Data = [];
      const aryIds = [];
      const hdLegendData = [];
      const existLabelRawNameList = [];
      const existLabelAgainRawNameList = [];
      this.series = [];
      this.xAxisData = [];
      this.useHumiditySectionLine = false;
      this.useCondensation95Line = false;
      this.humiditySectionLineMax = 0;
      this.numberRange = "";
      this.statusClass = "";

      //in monthly report, result object list has and only has 1 item: report group model.
      let reportGroup = this.resultObjectList[0];
      this.updateSearchOptions(reportGroup.groupName);

      this.$nextTick(() => {
        this.resultObjectList.forEach((reportGroup, $index) => {
          // this.updateSearchOptions(reportGroup.groupName);
          reportGroup.deviceIdList.forEach((deviceId) => {
            deviceIdList.push(deviceId);
            httpAry.push(this.createGetHttp(deviceId));
            aryIds.push(`deviceId=${deviceId}`);
            let _label = reportGroup.deviceIdDistinctNameDict[deviceId];
            //解决2组设备同名问题
            const existLabelIndex = series.findIndex((el) => el.name === _label);
            //解决2组以上设备同名问题
            const existLabelIndex2 = existLabelRawNameList.findIndex((el) => el === _label);
            if (existLabelIndex !== -1) {
              existLabelRawNameList.push(_label);
              series[existLabelIndex].name += `[${series[existLabelIndex].ascription.split("/")[1]}]`;
              legendData[existLabelIndex] = series[existLabelIndex].name;
              hdLegendData[existLabelIndex] = series[existLabelIndex].name;
              _label += `[${reportGroup.ascription.split("/")[1]}]`;
            } else if (existLabelIndex2 !== -1) {
              _label += `[${reportGroup.ascription.split("/")[1]}]`;
            }

            //解决2桥设备同名同组问题
            const existLabelAgainIndex = series.findIndex((el) => el.name === _label);
            //解决2桥以上设备同名同组问题
            const existLabelAgainIndex2 = existLabelAgainRawNameList.findIndex((el) => el === _label);
            if (existLabelAgainIndex !== -1) {
              existLabelAgainRawNameList.push(_label);
              series[existLabelAgainIndex].name += `[${series[existLabelAgainIndex].ascription.split("/")[0]}]`;
              legendData[existLabelAgainIndex] = series[existLabelAgainIndex].name;
              hdLegendData[existLabelAgainIndex] = series[existLabelAgainIndex].name;
              _label += `[${reportGroup.ascription.split("/")[0]}]`;
            } else if (existLabelAgainIndex2 !== -1) {
              _label += `[${reportGroup.ascription.split("/")[0]}]`;
            }

            series.push({
              name: _label,
              ascription: _label,
              animation: false,
              type: "line",
              data: [],
              lineStyle: {
                width: 3,
              },
            });
            legendData.push(_label);
            hdLegendData.push(_label);
          });
        });
        this.hdLegendData = hdLegendData;
        this.$http.get(`/statistics/ChartHumidityLine?${aryIds.join("&")}`).then(({ data = {} }) => {
          this.useHumiditySectionLine = data.useHumiditySectionLine;
          this.useCondensation95Line = data.useCondensation95Line;
          this.humiditySectionLineMax = data.humidityLineMax;
          const { humidityLineMin, humidityLineMax, extraLineList } = data;
          this.numberRange = JSON.stringify([humidityLineMin, humidityLineMax]);
          this.$http.all(httpAry).then(
            this.$http.spread((...resList) => {
              this.loading = false;
              const dataList = [];
              resList.forEach((res) => {
                const dataObj = {};
                const resList = res.data.dataList || [];
                const dataAry = resList.map((val) => {
                  var translatedStatisticsdate = this.translateXAxisStatisticsDate(val.StatisticsDate);
                  if (resList.length > 0 && xAxisData.length < resList.length) {
                    xAxisData.push(translatedStatisticsdate);
                  }
                  dataDateList.push(val.dataDate);
                  dataObj[translatedStatisticsdate] = val.value;
                  return val.value;
                });
                dataList.push(dataAry);
                if (res.data.errorLevel === "Error") this.statusClass = "Error";
                if (this.statusClass !== "Error" && res.data.errorLevel === "Warning") {
                  this.statusClass = "Warning";
                }
                humidity1Data.push(dataObj);
              });
              dataList.forEach((val, index) => {
                if (val.length === 0) {
                  series[index].data = new Array(xAxisData.length).fill("--");
                } else {
                  series[index].data = val;
                }
              });
              if (this.useHumiditySectionLine) {
                let lineData = [
                  {
                    name: "下限",
                    type: "average",
                    yAxis: humidityLineMin,
                    lineStyle: { color: "green" },
                  },
                  {
                    name: "上限",
                    yAxis: humidityLineMax,
                    lineStyle: { color: "red" },
                  },
                ];

                if (this.useCondensation95Line) {
                  lineData.push({
                    name: "结露",
                    yAxis: 95.0,
                    lineStyle: { color: "red" },
                  });
                }

                extraLineList.forEach((lineVal) => {
                  lineData.push({
                    name: "参考线",
                    type: "average",
                    yAxis: lineVal,
                    lineStyle: { color: "orange" },
                  });
                });

                series.forEach((val) => {
                  val.markLine = {
                    itemStyle: {
                      normal: {
                        lineStyle: { type: "solid" },
                        label: { show: true, position: "end" },
                      },
                    },
                    data: lineData,
                  };
                });
              }

              let reportGroup = "";
              if (this.resultObjectList && this.resultObjectList[0]) {
                reportGroup = this.resultObjectList[0].groupName;
              }

              let chartTitle = "";
              if (reportGroup && reportGroup !== "") {
                chartTitle = this.assembleChartTitle_monthly(dataDateList, deviceIdList, reportGroup);
              }
              this.$nextTick(() => {
                this.humidity1Data = humidity1Data;
                this.series = series;
                this.xAxisData = xAxisData;
                this.legendData = legendData;
                this.chartTitle = chartTitle;
                setTimeout(() => {
                  this.multiScreenshot();
                }, 500);
              });
            })
          );
        });
      });
    },
    /**
     * 提交图表数据, 请求下一个图表
     */
    multiScreenshot() {
      try {
        const historyChart = this.$refs.historyChart.historyChart;
        const dataSrc = historyChart.getDataURL({
          pixelRatio: 2,
          backgroundColor: "#fff",
        });
        const title = historyChart.getOption().title[0].text || "";
        const myFile = this.dataURLtoFile(dataSrc, `${title}.png`);
        this.monthReportTextModify(
          `正在绘制 ${this.resultObjectList[0].groupName} (${this.genneReportDeviceList.length + 1}/${this.reportGroupListLength})`
        );
        let form = new FormData();
        form.append("file", myFile);
        this.$http
          .post("/echartReport/UploadEchartReportImage", form)
          .then((res) => {
            if (res.data && res.data.imageFileId) {
              this.drawEchartsFailTimes = 0;
              this.genneReportDeviceList.push({
                echartReportImageId: res.data.imageFileId,
                groupId: this.resultObjectList[0].groupId,
                groupName: this.resultObjectList[0].groupName,
              });
              if (this.reportGroupList.length > 0) {
                this.resultObjectList = [this.reportGroupList.shift()];
                historyChart.dispose();
                setTimeout(() => {
                  this.getReportChartData();
                }, 300);
              } else {
                this.GenerateMonthlyReport();
              }
            }
          })
          .catch((error) => {
            console.error("error", error);
            this.$alert(`绘制 ${this.resultObjectList[0].deviceName} 发生错误，已停止生成月度报告，请重新生成`, {
              confirmButtonText: "确定",
              showClose: false,
              type: "error",
              callback: (action) => {
                console.log("stop");
                this.resultObjectList = [];
              },
            });
            this.loadingFullScreenClose();
            this.monthlyReportInProgress = false;
          });
      } catch (error) {
        console.error("error refresh multiScreenshot", error);
        if (this.drawEchartsFailTimes === 4) {
          this.$alert(`绘制 ${this.resultObjectList[0].deviceName} 发生错误，已停止生成月度报告，请重新生成`, {
            confirmButtonText: "确定",
            showClose: false,
            type: "error",
            callback: (action) => {
              this.resultObjectList = [];
              console.log("stop");
            },
          });
          this.loadingFullScreenClose();
          this.monthlyReportInProgress = false;
          return;
        }
        setTimeout(() => {
          console.log(`重新绘制 ${this.resultObjectList[0].deviceName}`);
          this.drawEchartsFailTimes++;
          this.multiScreenshot();
        }, 1000);
      }
    },
    GenerateMonthlyReport() {
      this.resultObjectList = [];
      this.monthReportTextAdd("正在生成报告...");
      this.$emit("resetSearchConfig");
      this.$http
        .post(`/echartReport/GenerateMonthlyReport`, {
          deviceParameterList: this.genneReportDeviceList,
          bridgeId: this.bridgeForm.bridge,
          imageOnly: this.imageOnlyReport,
          reportEndDate: dateTimeToString(this.monthlyReportEndDate, "yyyy-MM-dd"),
        })
        .then((res) => {
          console.log("GenerateMonthlyReport", res);
          this.downloadMonthlyEchartReport(res.data.reportId);
        })
        .catch(() => {
          this.loadingFullScreenClose();
        });
    },
    downloadMonthlyEchartReport(reportId) {
      this.loadingFullScreenClose();
      this.monthlyReportInProgress = false;
      this.resultObjectList = [];
      this.$alert(`月度报告生成完毕，请点击下载`, "提示", {
        confirmButtonText: "下载",
        showClose: false,
        type: "success",
      }).then(() => {
        const $url = "/echartReport/DownloadMonthlyReport?reportId=" + reportId;
        window.open($url);
      });
    },
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(",");
      var mime = arr[0].match(/:(.*?);/)[1];
      var bstr = atob(arr[1]);
      var n = bstr.length;
      var u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    /**
     * 下载
     */
    doDownData(type, item) {
      let $url = `/excel/Device?deviceId=${item.deviceId}&statisticsInterval=${item.interval}&dataCount=${item.dataCount}&dataEndDate=${item.endDate}`;
      if (type === 2) {
        $url = `/excel/Station?stationId=${item.stationId}&statisticsInterval=${item.interval}&dataCount=${item.dataCount}&dataEndDate=${item.endDate}`;
      }
      if (type === 3) {
        $url = `/excel/Bridge?bridgeId=${item.bridgeId}&statisticsInterval=${item.interval}&dataCount=${item.dataCount}&dataEndDate=${item.endDate}`;
      }
      window.open($url);
    },
    intervalChange(_ind, index, val) {
      let downloadDataList = [...this.downloadDataList];
      downloadDataList[_ind].children[index]["interval"] = val;
      this.downloadDataList = downloadDataList;
    },
    exportDataCountChange(_ind, index, val) {
      let downloadDataList = [...this.downloadDataList];
      downloadDataList[_ind].children[index]["dataCount"] = val;
      this.downloadDataList = downloadDataList;
    },
    exportEndDateChange(_ind, index, val) {
      let downloadDataList = [...this.downloadDataList];
      downloadDataList[_ind].children[index]["endDate"] = val;
      this.downloadDataList = downloadDataList;
    },
    /**
     * 返回http get请求
     * @param {String} id
     */
    createGetHttp(id) {
      // console.log("statistics get device data: " + JSON.stringify(this.search));
      return this.$http.get(`/statistics/DeviceData?deviceId=${id}&${qs.stringify(this.search)}`);
    },
    createGetHttp_humidityPercentage(id) {
      return this.$http.get(`/deviceData/HumidityPercentage?deviceId=${id}&${qs.stringify(this.search_humidityPercentage)}`
        + '&useDailyStatisticsData=' + this.humidityPercentageUseDailyStatisticsData + '&ignoreEmptyData=' + this.humidityPercentageIgnoreEmptyData);
    },
    /**
     * 清除已选
     */
    clearAllCheck() {
      this.checkedDeviceList = [];
      this.checkedDeviceObjectList = [];
    },
    /**
     */
    cancelSelectDeviec() {
      this.dialogSelectVisible = false;
      this.checkedDeviceList = JSON.parse(JSON.stringify(this.resultIdList));
      this.checkedDeviceObjectList = JSON.parse(JSON.stringify(this.resultObjectList));
    },
    /**
     * 请求图表数据, 湿度比例, 非月报
     */
    getChartData_humidityPercentage() {
      this.getChartData_humidityPercentage_actual();

      //精确-非精确日期范围由API提供
      // //检查日期范围
      // let hourlyStatisticsDataRange = new Date(new Date() - this.hourlyStatisticsDataExpireDays * 24 * 60 * 60 * 1000);
      // let humidityPercentageDataRange;
      // if (!this.search_humidityPercentage.dataDate || this.search_humidityPercentage.dataDate === "") {
      //   humidityPercentageDataRange = new Date();
      // } else {
      //   humidityPercentageDataRange = new Date(this.search_humidityPercentage.dataDate);
      // }
      // humidityPercentageDataRange = new Date(humidityPercentageDataRange - this.search_humidityPercentage.daysCount * 24 * 60 * 60 * 1000);

      // console.log("hourly data range: " + hourlyStatisticsDataRange);
      // console.log("humidity percentage data range: " + humidityPercentageDataRange);

      // //调用实际计算
      // if (humidityPercentageDataRange < hourlyStatisticsDataRange) {
      //   let message = dateTimeToString(hourlyStatisticsDataRange, "yyyy年MM月dd日") + "前的数据精度较低. 是否继续?";

      //   this.$confirm(message, "提示", {
      //     confirmButtonText: "确定",
      //     cancelButtonText: "取消",
      //     type: "warning",
      //   }).then(() => {
      //     this.getChartData_humidityPercentage_actual();
      //   });
      // } else {
      //   this.getChartData_humidityPercentage_actual();
      // }
    },
    getChartData_humidityPercentage_actual() {
      if (!this.isHumidityPercentageTree) return;
      if (this.monthlyReportInProgress) return;
      if (this.resultObjectList.length === 0) return;
      this.loading = true;
      const deviceIdList = [];
      let endDate = undefined;
      let daysCount = undefined;
      const httpAry = [];
      const xAxisData = [];
      const series = [];
      const legendData = [];
      const humidity1Data = [];
      const aryIds = [];
      const hdLegendData = [];
      const existLabelRawNameList = [];
      const existLabelAgainRawNameList = [];
      const h = this.$createElement;
      this.series = [];
      this.xAxisData = [];
      this.useHumiditySectionLine = false;
      this.useCondensation95Line = false;
      this.humiditySectionLineMax = 0;
      this.numberRange = "";
      this.statusClass = "";
      let warningMessage = "";
      const searchParameterSnapshot = JSON.stringify(this.search_humidityPercentage);
      let duplicateNameList = [];
      this.resultObjectList.forEach((val, $index) => {
        // console.log(val);
        deviceIdList.push(val.deviceId);
        httpAry.push(this.createGetHttp_humidityPercentage(val.deviceId));
        aryIds.push(`deviceId=${val.deviceId}`);
        let _label = val.label;
        //解决2组设备同名问题
        const existLabelIndex = duplicateNameList.findIndex((el) => el.name === _label);
        //解决2组以上设备同名问题
        const existLabelIndex2 = existLabelRawNameList.findIndex((el) => el === _label);
        if (existLabelIndex !== -1) {
          // console.log(`first [${duplicateNameList[existLabelIndex].ascription}]`);
          existLabelRawNameList.push(_label);
          // series[existLabelIndex].name += `[${series[existLabelIndex].ascription.split("/")[1]}]`;
          duplicateNameList[existLabelIndex].name += `[${duplicateNameList[existLabelIndex].ascription.split("/")[1]}]`;
          legendData[existLabelIndex] = duplicateNameList[existLabelIndex].name;
          hdLegendData[existLabelIndex] = duplicateNameList[existLabelIndex].name;
          _label += `[${val.ascription.split("/")[1]}]`;
        } else if (existLabelIndex2 !== -1) {
          _label += `[${val.ascription.split("/")[1]}]`;
        }

        //解决2桥设备同名同组问题
        const existLabelAgainIndex = series.findIndex((el) => el.name === _label);
        //解决2桥以上设备同名同组问题
        const existLabelAgainIndex2 = existLabelAgainRawNameList.findIndex((el) => el === _label);
        if (existLabelAgainIndex !== -1) {
          // console.log(`second [${duplicateNameList[existLabelIndex].ascription}]`);
          existLabelAgainRawNameList.push(_label);
          // series[existLabelAgainIndex].name += `[${series[existLabelAgainIndex].ascription.split("/")[0]}]`;
          duplicateNameList[existLabelIndex].name += `[${duplicateNameList[existLabelIndex].ascription.split("/")[0]}]`;
          legendData[existLabelAgainIndex] = duplicateNameList[existLabelAgainIndex].name;
          hdLegendData[existLabelAgainIndex] = duplicateNameList[existLabelAgainIndex].name;
          _label += `[${val.ascription.split("/")[0]}]`;
        } else if (existLabelAgainIndex2 !== -1) {
          _label += `[${val.ascription.split("/")[0]}]`;
        }

        duplicateNameList.push({
          name: _label,
          ascription: val.ascription,
          deviceId: val.deviceId,
        });
        legendData.push(_label);
        hdLegendData.push(_label);
      });
      this.hdLegendData = hdLegendData;
      this.$http.all(httpAry).then(
        this.$http.spread((...resList) => {
          const dataAry_below = [];
          const dataAry_between = [];
          const dataAry_after = [];
          const dataAry_offline = [];
          let firstLine = 0;
          let secondLine = 0;
          let humidityPercentageResultUseDailyStatisticsData = false;
          let humidityPercentageResultIgnoreEmptyData = false;
          let firstDataDate = undefined;
          let lastDataDate = undefined;

          resList.forEach((res) => {
            // console.log(res.data);
            const dataObj = {};
            const item = res.data;
            firstLine = item.firstLine;
            secondLine = item.secondLine;
            humidityPercentageResultUseDailyStatisticsData = humidityPercentageResultUseDailyStatisticsData || item.useDailyStatisticsData;
            humidityPercentageResultIgnoreEmptyData = humidityPercentageResultIgnoreEmptyData || item.ignoreEmptyData;

            if(!firstDataDate){
              firstDataDate = item.firstDataDateStatistics;
            }
            if(!lastDataDate){
              lastDataDate = item.lastDataDateStatistics;
            }

            // //test
            // item.percentage_humidityBeforeLine = 80;
            // item.percentage_humidityBetweenLine = 65;
            // item.percentage_humidityAfterLine = 15;

            if (
              // resList.length > 0 &&
              // xAxisData.length < resList.length &&
              item.errorLevel === "Normal"
            ) {
              let name = item.deviceName;
              // console.log(duplicateNameList);
              // console.log(item.deviceId);
              let nameIndex = duplicateNameList.findIndex((el) => {
                return el.deviceId === item.deviceId;
              });
              if (nameIndex >= 0) {
                name = duplicateNameList[nameIndex].name;
              }

              // console.log(nameIndex + "_" + name);
              xAxisData.push(name);
              dataAry_below.push(item.percentage_humidityBeforeLine.toFixed(2));
              dataAry_between.push(item.percentage_humidityBetweenLine.toFixed(2));
              dataAry_after.push(item.percentage_humidityAfterLine.toFixed(2));
              if (item.percentage_humidityOffline > 0) {
                dataAry_offline.push(item.percentage_humidityOffline.toFixed(2));
              }
              else {
                dataAry_offline.push(undefined);
              }

              // if (item.dailyDataCount > 0) {
              //   warningMessage =
              //     warningMessage +
              //     "<p>" +
              //     name +
              //     "最早精确数据时间: " +
              //     item.firstHourlyDataDate +
              //     ", 分析中包含非精确数据(日抽样): " +
              //     item.dailyDataCount +
              //     "日. </p>";
              // }

              // console.log(name + "_" + item.firstHourlyDataDate + "_" + item.dailyDataCount);
            }
            if (item.errorLevel === "Error") this.statusClass = "Error";
            if (this.statusClass !== "Error" && item.errorLevel === "Warning") {
              this.statusClass = "Warning";
            }

            if (!endDate) {
              endDate = item.reportDate;
            }
            if (!daysCount) {
              daysCount = item.daysCount;
            }
          });

          this.humidityPercentageResultUseDailyStatisticsData = humidityPercentageResultUseDailyStatisticsData;

          const labelOption = {
            show: true,
            rotate: 90,
            align: "left",
            verticalAlign: "middle",
            position: "insideBottom",
            distance: 15,
            formatter: "{c}%  {a}",
            fontSize: 15,
            color: "#333333",
            rich: {
              name: {},
            },
          };

          const labelOption_custom = JSON.parse(JSON.stringify(labelOption));
          labelOption_custom.color = "#EEEEEE";

          if (!this.humidityPercentageDisplayAfterOnly) {
            series.push({
              name: "湿度 ≤" + firstLine + "%",
              ascription: firstLine + "%",
              type: "bar",
              emphasis: {
                focus: "series",
              },
              label: labelOption,
              color: "#91CC75",
              data: dataAry_below,
            });
          }
          if (!this.humidityPercentageDisplayAfterOnly) {
            series.push({
              name: "湿度 " + firstLine + "% ~ " + secondLine + "%",
              ascription: firstLine + "% ~ " + secondLine + "%",
              type: "bar",
              emphasis: {
                focus: "series",
              },
              label: labelOption,
              color: "#FAC858",
              data: dataAry_between,
            });
          }


          series.push({
            name: "湿度 ≥" + secondLine + "%",
            ascription: secondLine + "%",
            type: "bar",
            emphasis: {
              focus: "series",
            },
            label: labelOption,
            color: "#EE6666",
            data: dataAry_after,
          });

          if (!this.humidityPercentageDisplayAfterOnly) {
            series.push({
              name: "数据中断",
              ascription: "数据中断",
              type: "bar",
              emphasis: {
                focus: "series",
              },
              label: labelOption,
              color: "#A9A9A9",
              data: dataAry_offline,
            });
          }


          this.loading = false;

          //检查是否参数已经改变(主要是手动输入的湿度线)
          const currentSearchParameter = JSON.stringify(this.search_humidityPercentage);
          if (currentSearchParameter != searchParameterSnapshot) {
            return;
          }

          let chartTitle = this.assembleChartTitle_humidityPercentage(firstDataDate, lastDataDate, daysCount, deviceIdList);

          this.$nextTick(() => {
            this.humidity1Data = [];
            this.series = series;
            this.xAxisData = xAxisData;
            this.legendData = legendData;
            this.chartTitle = chartTitle;

            if (warningMessage.length > 0) {
              this.$confirm(warningMessage, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                dangerouslyUseHTMLString: true,
                type: "warning",
              });
            }
          });
          if (this.timeFunc) {
            clearInterval(this.timeFunc);
            this.timeFunc = setInterval(() => {
              this.getChartData_humidityPercentage();
            }, REFRESH_DATA_HISTROY_TIME);
          }
        })
      );
    },
    /**
     * 请求图表数据, 非月报
     */
    getChartData() {
      if (this.isHumidityPercentageTree) return;
      if (this.monthlyReportInProgress) return;
      if (this.resultObjectList.length === 0) return;
      this.loading = true;
      const deviceIdList = [];
      const dataDateList = [];
      const httpAry = [];
      const xAxisData = [];
      const series = [];
      const legendData = [];
      const humidity1Data = [];
      const aryIds = [];
      const hdLegendData = [];
      const existLabelRawNameList = [];
      const existLabelAgainRawNameList = [];
      this.series = [];
      this.xAxisData = [];
      this.useHumiditySectionLine = false;
      this.useCondensation95Line = false;
      this.humiditySectionLineMax = 0;
      this.numberRange = "";
      this.statusClass = "";
      this.resultObjectList.forEach((val, $index) => {
        deviceIdList.push(val.deviceId);
        httpAry.push(this.createGetHttp(val.deviceId));
        aryIds.push(`deviceId=${val.deviceId}`);
        let _label = val.label;
        //解决2组设备同名问题
        const existLabelIndex = series.findIndex((el) => el.name === _label);
        //解决2组以上设备同名问题
        const existLabelIndex2 = existLabelRawNameList.findIndex((el) => el === _label);
        // console.log(JSON.stringify(existLabelRawNameList));
        if (existLabelIndex !== -1) {
          // console.log(`first [${series[existLabelIndex].ascription}]`);
          existLabelRawNameList.push(_label);
          series[existLabelIndex].name += `[${series[existLabelIndex].ascription.split("/")[1]}]`;
          legendData[existLabelIndex] = series[existLabelIndex].name;
          hdLegendData[existLabelIndex] = series[existLabelIndex].name;
          _label += `[${val.ascription.split("/")[1]}]`;
        } else if (existLabelIndex2 !== -1) {
          _label += `[${val.ascription.split("/")[1]}]`;
        }

        //解决2桥设备同名同组问题
        const existLabelAgainIndex = series.findIndex((el) => el.name === _label);
        //解决2桥以上设备同名同组问题
        const existLabelAgainIndex2 = existLabelAgainRawNameList.findIndex((el) => el === _label);
        if (existLabelAgainIndex !== -1) {
          // console.log(`second [${series[existLabelIndex].ascription}]`);
          existLabelAgainRawNameList.push(_label);
          series[existLabelAgainIndex].name += `[${series[existLabelAgainIndex].ascription.split("/")[0]}]`;
          legendData[existLabelAgainIndex] = series[existLabelAgainIndex].name;
          hdLegendData[existLabelAgainIndex] = series[existLabelAgainIndex].name;
          _label += `[${val.ascription.split("/")[0]}]`;
        } else if (existLabelAgainIndex2 !== -1) {
          _label += `[${val.ascription.split("/")[0]}]`;
        }

        series.push({
          name: _label,
          ascription: val.ascription,
          type: "line",
          data: [],
          // lineStyle: {
          //   width: 3
          // }
        });
        legendData.push(_label);
        hdLegendData.push(_label);
      });
      this.hdLegendData = hdLegendData;
      this.$http.get(`/statistics/ChartHumidityLine?${aryIds.join("&")}`).then(({ data = {} }) => {
        this.useHumiditySectionLine = data.useHumiditySectionLine;
        this.useCondensation95Line = data.useCondensation95Line;
        this.humiditySectionLineMax = data.humidityLineMax;
        const { humidityLineMin, humidityLineMax, extraLineList } = data;
        this.numberRange = JSON.stringify([humidityLineMin, humidityLineMax]);
        this.$http.all(httpAry).then(
          this.$http.spread((...resList) => {
            //process reslist for no interval query.
            if (this.search.interval === "NA") {
              console.log("no statistics interval, insert empty data to match time line");
              let insertCount = 0;
              let fullTimestampList = [];
              let timestampStatisticsDateDict = {};
              resList.forEach((res) => {
                res.data.dataList.forEach((dataItem) => {
                  var date = StatisticsDateToDate(dataItem.StatisticsDate);
                  if (date && fullTimestampList.indexOf(date.getTime()) < 0) {
                    fullTimestampList.push(date.getTime());
                    timestampStatisticsDateDict[date.getTime()] = dataItem.StatisticsDate;
                  }
                });
              });
              fullTimestampList.sort();

              resList.forEach((res) => {
                fullTimestampList.forEach((timestamp) => {
                  let timestampComplete = false;
                  for (let i = 0; i < res.data.dataList.length; i++) {
                    let dataItem = res.data.dataList[i];
                    let dataItemDate = StatisticsDateToDate(dataItem.StatisticsDate);
                    if (dataItemDate.getTime() < timestamp) {
                      continue;
                    } else if (dataItemDate.getTime() == timestamp) {
                      timestampComplete = true;
                      break;
                    } else if (dataItemDate.getTime() > timestamp) {
                      let emptyItem = {
                        StatisticsDate: timestampStatisticsDateDict[timestamp],
                        value: null,
                      };
                      res.data.dataList.splice(i, 0, emptyItem);
                      timestampComplete = true;
                      insertCount++;
                      break;
                    }
                  }

                  if (!timestampComplete) {
                    let emptyItem = {
                      StatisticsDate: timestampStatisticsDateDict[timestamp],
                      value: null,
                    };
                    res.data.dataList.splice(res.data.dataList.length, 0, emptyItem);
                    insertCount++;
                  }
                });
              });
              console.log("insert empty data to match time line: " + insertCount);
            }

            this.loading = false;
            const dataList = [];
            resList.forEach((res) => {
              const dataObj = {};
              const resList = res.data.dataList || [];
              const dataAry = resList.map((val) => {
                var translatedStatisticsdate = this.translateXAxisStatisticsDate(val.StatisticsDate);
                if (resList.length > 0 && xAxisData.length < resList.length) {
                  xAxisData.push(translatedStatisticsdate);
                }
                dataDateList.push(val.dataDate);
                dataObj[translatedStatisticsdate] = val.value;
                return val.value;
              });
              dataList.push(dataAry);
              if (res.data.errorLevel === "Error") this.statusClass = "Error";
              if (this.statusClass !== "Error" && res.data.errorLevel === "Warning") {
                this.statusClass = "Warning";
              }
              humidity1Data.push(dataObj);
            });
            dataList.forEach((val, index) => {
              if (val.length === 0) {
                series[index].data = new Array(xAxisData.length).fill("--");
              } else {
                series[index].data = val;
              }
            });
            if (this.useHumiditySectionLine) {
              let lineData = [
                {
                  name: "下限",
                  type: "average",
                  yAxis: humidityLineMin,
                  lineStyle: { color: "green" },
                },
                {
                  name: "上限",
                  yAxis: humidityLineMax,
                  lineStyle: { color: "red" },
                },
              ];

              if (this.useCondensation95Line) {
                lineData.push({
                  name: "结露",
                  yAxis: 95.0,
                  lineStyle: { color: "#b71540" },
                });
              }

              extraLineList.forEach((lineVal) => {
                lineData.push({
                  name: "参考线",
                  type: "average",
                  yAxis: lineVal,
                  lineStyle: { color: "orange" },
                });
              });

              series.forEach((val) => {
                val.markLine = {
                  itemStyle: {
                    normal: {
                      lineStyle: { type: "solid" },
                      label: { show: true, position: "end" },
                    },
                  },
                  data: lineData,
                };
              });
            }

            if (this.search.interval === "NA") {
              series.forEach((seriesItem) => {
                seriesItem.connectNulls = true;
              });
            }

            let chartTitle = this.assembleChartTitle(dataDateList, deviceIdList);
            this.$nextTick(() => {
              this.humidity1Data = humidity1Data;
              this.series = series;
              this.xAxisData = xAxisData;
              this.legendData = legendData;
              this.chartTitle = chartTitle;
            });
            if (this.timeFunc) {
              clearInterval(this.timeFunc);
              this.timeFunc = setInterval(() => {
                this.getChartData();
              }, REFRESH_DATA_HISTROY_TIME);
            }
          })
        );
      });
    },
    /**
     * 选则数据弹窗确定事件
     */
    doSelectDevice() {
      this.resultIdList = JSON.parse(JSON.stringify(this.checkedDeviceList));
      if (this.resultIdList.length > 1 && !this.search.insertBlankData && this.search.interval != "NA"
        && !this.isHumidityPercentageTree) {
        this.$emit("onBlankData", true);
      }
      this.resultObjectList = JSON.parse(JSON.stringify(this.checkedDeviceObjectList));
      this.dialogSelectVisible = false;
      if (this.isHumidityPercentageTree) {
        this.getChartData_humidityPercentage();
      } else {
        this.getChartData();
      }
    },
    /**
     * 数据checkbox变化
     * @param {Object} data
     */
    deviceSelect(data) {
      if (this.checkedDeviceList.indexOf(data.deviceId) > -1) {
        const $index = this.checkedDeviceObjectList.findIndex((val) => val.stationId === data.stationId);
        if ($index > -1) {
          this.checkedDeviceObjectList.splice($index, 0, data);
        } else {
          this.checkedDeviceObjectList.push(data);
        }
      } else {
        this.checkedDeviceObjectList.forEach((val, index) => {
          if (val.deviceId === data.deviceId) {
            this.checkedDeviceObjectList.splice(index, 1);
          }
        });
      }
    },
    /**
     * tree jsx
     * @param {h} data
     * @param {Object} node
     * @param {Object} data
     */
    renderContent(h, { node, data }) {
      return (
        <div class="tree-node">
          {node.level > 3 ? (
            <el-checkbox on-change={() => this.deviceSelect(data)} label={data.deviceId} key={data.deviceId}>
              {node.label}
            </el-checkbox>
          ) : (
            <span class="node-label">{node.label}</span>
          )}
          <span></span>
        </div>
      );
    },
    /**
     * tree lazy 懒加载
     * @param node
     * @param resolve
     */
    loadNodeLeft(node, resolve) {
      if (node.level === 0) return resolve(this.treeData);
      this.getDataList(node, resolve, stationRightList, false);
    },
    /**
     * tree lazy 懒加载
     * @param node
     * @param resolve
     */
    loadNodeRight(node, resolve) {
      if (node.level === 0) return resolve(this.treeDataRight);
      this.getDataList(node, resolve, stationRightList, true);
    },
    /**
     * 加载数据
     * @param node
     * @param callback
     */
    getDataList(node, callback, stationRightList, isRight) {
      //read cache.
      if (node.level === 3) {
        var cacheKey = node.data.deviceId;
        var leafItemList = this.stationDataGroupCache[cacheKey];
        if (!leafItemList || leafItemList.length === 0) {
          console.log("read leaf item cache failed.");
          callback([]);
        } else {
          callback(leafItemList);
          return;
        }
      }

      //read bridge/station info from api
      let $url = "/bridge/BridgeInfo?bridgeId";
      let $id = node.data.bridgeId;
      let rightStationList = stationRightList[node.data.label];
      if (node.level === 2) {
        $url = "/bridge/StationInfo?stationId";
        $id = node.data.stationId;
      }
      this.$http.get(`${$url}=${$id}`).then((res) => {
        const dataAry = [];

        if (node.level === 1) {
          //检查限制权限桥
          if (!this.isAdmin && !this.isStatisticsAccessApproved && res.data.isStatisticsAccessRestricted) {
            this.$message({
              message: "您登录的用户没有访问[" + node.data.label + "]自定义历史数据的权限. 请联系管理员.",
              type: "error",
              duration: 10000,
            });
          } else {
            const stationList = res.data.stationList || [];
            stationList.forEach((val) => {
              const dataObj = {
                label: val.stationName,
                deviceId: val.stationId,
                stationId: val.stationId,
                leaf: false,
                bridgeId: node.data.bridgeId,
                bridgeName: node.label,
              };

              this.nodeIdNodeNameDict[val.stationId] = val.stationName;
              this.nodeIdParentIdDict[val.stationId] = node.data.bridgeId;

              if (rightStationList) {
                const inRight = rightStationList.findIndex((el) => el === val.stationName) !== -1;
                if (isRight) {
                  if (inRight) {
                    dataAry.push(dataObj);
                  }
                } else {
                  if (!inRight) {
                    dataAry.push(dataObj);
                  }
                }
              } else {
                dataAry.push(dataObj);
              }
            });
          }
        } else if (node.level === 2) {
          const deviceList = res.data.deviceList || [];
          let humidityList = [];
          let temperatureList = [];
          let pressureList = [];
          let flowList = [];
          let volumeList = [];
          let flagList = [];
          let runningTimeList = [];
          let powerList = [];
          let otherList = [];
          let absoluteHumidityList = [];
          let dewPointTemperatureList = [];
          deviceList.forEach((device) => {
            //湿度比例图模式下只能选择湿度数据
            if (this.isHumidityPercentageTree && !device.IsHumidityData) {
              // continue;
              return true;
            }

            var leafItem = {
              label: device.deviceName,
              deviceId: device.deviceId,
              stationId: device.stationId,
              bridgeId: node.data.bridgeId,
              ascription: `${node.data.bridgeName}/${node.data.label}`,
              leaf: true,
            };

            this.nodeIdNodeNameDict[device.deviceId] = device.deviceName;
            this.nodeIdParentIdDict[device.deviceId] = device.stationId;

            //按单位分文件夹
            if (device.unit === "%" && device.deviceName.indexOf("湿度") >= 0) {
              humidityList.push(leafItem);
            } else if (device.unit === "℃") {
              if (device.deviceName.indexOf("露点温度") >= 0) {
                dewPointTemperatureList.push(leafItem);
              } else {
                temperatureList.push(leafItem);
              }
            } else if (device.unit.toLowerCase() === "pa" || device.unit.toLowerCase() === "kpa") {
              pressureList.push(leafItem);
            } else if (device.unit === "m?/h" || device.unit === "m³/h") {
              leafItem.label = leafItem.label.replace("m?/h", "m³/h");
              volumeList.push(leafItem);
            } else if (device.unit === "m/s") {
              flowList.push(leafItem);
            } else if (device.unit === "无") {
              flagList.push(leafItem);
            } else if (device.unit === "小时" || device.unit === "分钟") {
              runningTimeList.push(leafItem);
            } else if (device.unit === "g/kg") {
              absoluteHumidityList.push(leafItem);
            } else if (device.unit.toLowerCase() === "v" || device.unit.toLowerCase() === "a" || device.unit.toLowerCase() === "w" 
              || device.unit.toLowerCase() === "kw" || device.unit.toLowerCase() === "kwh" || device.unit.toLowerCase() === "kw·h") {
              powerList.push(leafItem);
            } else {
              otherList.push(leafItem);
            }
          });

          if (humidityList.length > 0) {
            var cacheKey = node.data.stationId + "_湿度";
            var folderItem = {
              label: "湿度",
              deviceId: cacheKey,
              stationId: node.data.stationId,
              bridgeId: node.data.bridgeId,
              ascription: node.data.bridgeName + "/" + node.data.label,
              leaf: false,
            };
            dataAry.push(folderItem);
            this.stationDataGroupCache[cacheKey] = humidityList;
          }
          if (temperatureList.length > 0) {
            var cacheKey = node.data.stationId + "_温度";
            var folderItem = {
              label: "温度",
              deviceId: cacheKey,
              stationId: node.data.stationId,
              bridgeId: node.data.bridgeId,
              ascription: node.data.bridgeName + "/" + node.data.label,
              leaf: false,
            };
            dataAry.push(folderItem);
            this.stationDataGroupCache[cacheKey] = temperatureList;
          }
          if (pressureList.length > 0) {
            var cacheKey = node.data.stationId + "_压力";
            var folderItem = {
              label: "压力",
              deviceId: cacheKey,
              stationId: node.data.stationId,
              bridgeId: node.data.bridgeId,
              ascription: node.data.bridgeName + "/" + node.data.label,
              leaf: false,
            };
            dataAry.push(folderItem);
            this.stationDataGroupCache[cacheKey] = pressureList;
          }
          if (powerList.length > 0) {
            var cacheKey = node.data.stationId + "_供电";
            var folderItem = {
              label: "供电",
              deviceId: cacheKey,
              stationId: node.data.stationId,
              bridgeId: node.data.bridgeId,
              ascription: node.data.bridgeName + "/" + node.data.label,
              leaf: false,
            };
            dataAry.push(folderItem);
            this.stationDataGroupCache[cacheKey] = powerList;
          }
          if (volumeList.length > 0) {
            var cacheKey = node.data.stationId + "_流量";
            var folderItem = {
              label: "流量",
              deviceId: cacheKey,
              stationId: node.data.stationId,
              bridgeId: node.data.bridgeId,
              ascription: node.data.bridgeName + "/" + node.data.label,
              leaf: false,
            };
            dataAry.push(folderItem);
            this.stationDataGroupCache[cacheKey] = volumeList;
          }
          if (flowList.length > 0) {
            var cacheKey = node.data.stationId + "_风速";
            var folderItem = {
              label: "风速",
              deviceId: cacheKey,
              stationId: node.data.stationId,
              bridgeId: node.data.bridgeId,
              ascription: node.data.bridgeName + "/" + node.data.label,
              leaf: false,
            };
            dataAry.push(folderItem);
            this.stationDataGroupCache[cacheKey] = flowList;
          }
          if (absoluteHumidityList.length > 0) {
            var cacheKey = node.data.stationId + "_含湿量";
            var folderItem = {
              label: "含湿量",
              deviceId: cacheKey,
              stationId: node.data.stationId,
              bridgeId: node.data.bridgeId,
              ascription: node.data.bridgeName + "/" + node.data.label,
              leaf: false,
            };
            dataAry.push(folderItem);
            this.stationDataGroupCache[cacheKey] = absoluteHumidityList;
          }
          if (dewPointTemperatureList.length > 0) {
            var cacheKey = node.data.stationId + "_露点温度";
            var folderItem = {
              label: "露点温度",
              deviceId: cacheKey,
              stationId: node.data.stationId,
              bridgeId: node.data.bridgeId,
              ascription: node.data.bridgeName + "/" + node.data.label,
              leaf: false,
            };
            dataAry.push(folderItem);
            this.stationDataGroupCache[cacheKey] = dewPointTemperatureList;
          }
          if (flagList.length > 0) {
            var cacheKey = node.data.stationId + "_运行状态";
            var folderItem = {
              label: "运行状态",
              deviceId: cacheKey,
              stationId: node.data.stationId,
              bridgeId: node.data.bridgeId,
              ascription: node.data.bridgeName + "/" + node.data.label,
              leaf: false,
            };
            dataAry.push(folderItem);
            this.stationDataGroupCache[cacheKey] = flagList;
          }
          if (runningTimeList.length > 0) {
            var cacheKey = node.data.stationId + "_运行时间";
            var folderItem = {
              label: "运行时间",
              deviceId: cacheKey,
              stationId: node.data.stationId,
              bridgeId: node.data.bridgeId,
              ascription: node.data.bridgeName + "/" + node.data.label,
              leaf: false,
            };
            dataAry.push(folderItem);
            this.stationDataGroupCache[cacheKey] = runningTimeList;
          }
          if (otherList.length > 0) {
            var cacheKey = node.data.stationId + "_其他";
            var folderItem = {
              label: "其他",
              deviceId: cacheKey,
              stationId: node.data.stationId,
              bridgeId: node.data.bridgeId,
              ascription: node.data.bridgeName + "/" + node.data.label,
              leaf: false,
            };
            dataAry.push(folderItem);
            this.stationDataGroupCache[cacheKey] = otherList;
          }
        }
        callback(dataAry);
      });
    },
    /**
     * 定时刷新
     * @param {Boolean} val
     */
    checkChange(val) {
      if (!val) {
        clearInterval(this.timeFunc);
        this.timeFunc = null;
      } else {
        this.timeFunc = setInterval(() => {
          this.getChartData();
        }, REFRESH_DATA_HISTROY_TIME);
      }
    },
    nodeExpand(obj, node, ele) {
      if (node.level !== 1) return;
      const $index = this.treeDataRight.findIndex((val) => val.bridgeId === obj.bridgeId);
      this.$nextTick(() => {
        if ($index > -1) {
          try {
            this.$refs.bridgeTree1.$children.forEach((el) => {
              if (el.$refs.node.innerText === node.label) {
                if (!el.expanded) {
                  this.$refs.bridgeTree1.treeItems[$index].click();
                  el.expanded = true;
                }
              }
            });
          } catch (error) {
            console.error(error);
          }
        }
      });
    },
    nodeCollapse(obj, node, ele) {
      if (node.level !== 1) return;
      const $index = this.treeDataRight.findIndex((val) => val.bridgeId === obj.bridgeId);
      this.$nextTick(() => {
        if ($index > -1) {
          try {
            this.$refs.bridgeTree1.$children.forEach((el) => {
              if (el.$refs.node.children[0].innerText === node.label) {
                if (el.expanded) {
                  this.$refs.bridgeTree1.treeItems[$index].click();
                  el.expanded = false;
                }
              }
            });
          } catch (error) {
            console.error(error);
          }
        }
      });
    },
    nodeExpandRight(obj, node, ele) {
      if (node.level !== 1) return;
      const $index = this.treeData.findIndex((val) => val.bridgeId === obj.bridgeId);
      this.$nextTick(() => {
        if ($index > -1) {
          try {
            this.$refs.bridgeTree.$children.forEach((el) => {
              if (el.$refs.node.innerText === node.label) {
                if (!el.expanded) {
                  this.$refs.bridgeTree.treeItems[$index].click();
                  el.expanded = true;
                }
              }
            });
          } catch (error) {
            console.error(error);
          }
        }
      });
    },
    nodeCollapseRight(obj, node, ele) {
      if (node.level !== 1) return;
      const $index = this.treeData.findIndex((val) => val.bridgeId === obj.bridgeId);
      this.$nextTick(() => {
        if ($index > -1) {
          try {
            this.$refs.bridgeTree.$children.forEach((el) => {
              if (el.$refs.node.children[0].innerText === node.label) {
                if (el.expanded) {
                  this.$refs.bridgeTree.treeItems[$index].click();
                  el.expanded = false;
                }
              }
            });
          } catch (error) {
            console.error(error);
          }
        }
      });
    },
  },
  destroyed() {
    clearInterval(this.timeFunc);
    this.timeFunc = null;
  },
};
</script>
<style lang="scss">
.monthly-report-form-input {
  margin-bottom: 30px;
}

.monthly-report-form-input-key {
  font-weight: 700;
}

.monthly-report-form-input-box {
  width: 400px;
}

.el-progress-bar {
  padding-right: 90px;
  margin-right: -90px;
}

.history-block {
  .tree-node {
    .node-label {
      font-size: 16px;
    }

    .el-checkbox {
      font-weight: normal;
    }

    .el-checkbox__label {
      font-size: 15px;
    }
  }
}

.loading-icon-src {
  font-size: 40px;
  display: block;
  height: 46px;
  margin-bottom: 20px;
  position: relative;

  &::before {
    position: absolute;
    left: calc(50% - 20px);
    transform: translateX(-50%);
    animation: rotate 1s linear infinite;
  }
}

.choseBridge {
  .el-form-item__label {
    font-weight: 500;
    font-size: 16px;
    margin-right: 30px;
    color: #333;
  }

  .el-form-item__content {
    padding-left: 60px;
  }

  .el-radio {
    line-height: 35px;
    display: block;

    &.monthly-report-form-item {
      display: inline-block;
    }
  }
}

.humidity-percentage-setting {
  width: 600px;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(359deg);
  }
}
</style>
<style lang='scss' scoped>
.history-block {
  height: 100%;
  width: 100%;
  // min-height: 450px;
  box-sizing: border-box;
  background-color: #fff;
  position: relative;
}

.dialog-title {
  span {
    font-size: 14px;
  }
}

.humidity-percentage-title {
  display: flex;
  justify-content: space-between;
}

.no-device {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    font-size: 32px;
    color: #aaa;
    letter-spacing: 2px;
  }
}

.el-table th,
.el-table td {
  text-align: center;
}

.dialog-footer {
  text-align: right;
}

.clear-btn {
  position: absolute;
  top: 10px;
  right: 30px;
  color: #f56c6c;
}

.warp-column {
  position: absolute;
  top: 5px;
  right: 35px;
  z-index: 22;

  .dh-label {
    float: left;
    margin-right: 10px;
  }
}

.el-checkbox-group {
  position: relative;
  display: flex;

  &::after {
    content: " ";
    display: block;
    width: 1px;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 50%;
    background-color: #eaeaea;
  }

  .bridge-tree {
    width: 50%;
  }
}

.month-report-text-wrap {
  position: fixed;
  width: 800px;
  left: 50%;
  top: 50%;
  padding: 100px 30px;
  background-color: #fff;
  transform: translate(-50%, -50%);
  z-index: 10000;

  i {
    color: #409eff;
  }

  p {
    margin: 5px 0;
    font-size: 13px;
    color: #333;
  }

  .gen {
    color: #409eff;
    font-size: 14px;
    text-align: center;
    margin-bottom: 50px;
  }
}

.generate-report-table-row {
  height: 40px;
}
</style>
